// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2attT","range":"MonthRangeSwitch_range__9RSZ3","disabled":"MonthRangeSwitch_disabled__1LBnX"};